





























































import { ProfileFilter } from 'client-website-ts-library/filters';
import { API, Config } from 'client-website-ts-library/services';
import { Profile, WebsiteLevel } from 'client-website-ts-library/types';
import { Component, Vue, Prop } from 'vue-property-decorator';

import NavigationLink from './NavigationLink.vue';

@Component({
  components: {
    NavigationLink,
  },
})
export default class Navigation extends Vue {
    @Prop()
    private readonly mobileNavActive!: boolean;

    @Prop()
    private readonly isStuck!: boolean;

    public profile: Profile | null = null;

    mounted() {
      API.Profiles.Get(Config.Website.Settings!.WebsiteId, true).then((profile) => {
        this.profile = profile;
      });
    }
}
